import toastr from 'toastr';

import * as actions from './actionsTypes';
import EmployeesVacationsServices from './employeesVacations.service';
import errorManage from '../../errorManage';
import { setEmployeeHalfDayData } from '../../../pages/vacations/employees_vacations/utils/employeeHalfDays';

export const getEmployeesVacations = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEES_VACATIONS,
      payload: true,
    });
    
    const resp = await EmployeesVacationsServices.getEmployeesVacations(filters);
    const data = resp.data.data.map((employee) => {
      return {
        ...employee,
        employeeHalfDays: setEmployeeHalfDayData(employee?.dias_descanso?? []),
      }
    });
    dispatch({
      type: actions.GET_EMPLOYEES_VACATIONS,
      payload: { count: resp.data.count, data },
    });
    dispatch({
      type: actions.FAIL_EMPLOYEES_VACATIONS,
      payload: "",
    });
  } catch (error) {
    console.log(error);
    errorManage(error, dispatch, actions.FAIL_EMPLOYEES_VACATIONS);
  } finally {
    dispatch({
      type: actions.IS_LOADING_EMPLOYEES_VACATIONS,
      payload: false,
    });
  }
};

export const updateEmployeeHalfDays = (employeeId, data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.IS_LOADING_UPDATE_EMPLOYEE_HALF_DAYS,
      payload: true,
    });
    debugger
    const { employeesVacations } = getState().employeesVacations;
    const { count, data: _employeesVacations } = employeesVacations;
    //encontrar empleado y actializar dias de descanso
    const resp = await EmployeesVacationsServices.updateEmployeeHalfDays(employeeId, data);
    /* Todo: Falta comprobar codigo de empleado en employee */
    const employee = _employeesVacations.find((employee) => employee.codigo_empleado === employeeId);
    if(employee){
      employee.dias_descanso = resp.data.dias_descanso;
    }
    dispatch({
      type: actions.GET_EMPLOYEES_VACATIONS,
      payload: { count, data: _employeesVacations },
    });
    dispatch({
      type: actions.FAIL_UPDATE_EMPLOYEE_HALF_DAYS,
      payload: "",
    });
    toastr.success('Días de descanso actualizados correctamente');
  } catch (error) {
    errorManage(error, dispatch, actions.FAIL_UPDATE_EMPLOYEE_HALF_DAYS);
  } finally {
    dispatch({
      type: actions.IS_LOADING_UPDATE_EMPLOYEE_HALF_DAYS,
      payload: false,
    });
  }
};